import { render, staticRenderFns } from "./Setor.vue?vue&type=template&id=0fa212a1&scoped=true&"
import script from "./Setor.vue?vue&type=script&lang=js&"
export * from "./Setor.vue?vue&type=script&lang=js&"
import style0 from "./Setor.vue?vue&type=style&index=0&id=0fa212a1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa212a1",
  null
  
)

export default component.exports